import { __read } from 'tslib';
import { createContext } from '../utils/createContext.js';

/**
 * SelectLegacyProvider
 *
 * Create context and provider for the Select components
 *
 */
var _a = __read(createContext({
    name: "Select",
}), 2), useSelectLegacyContext = _a[0], SelectLegacyContext = _a[1];
var SelectLegacyConsumer = SelectLegacyContext.Consumer;
var SelectLegacyProvider = SelectLegacyContext.Provider;

export { SelectLegacyConsumer, SelectLegacyProvider, useSelectLegacyContext };
//# sourceMappingURL=SelectLegacyProvider.js.map
